import React from "react";
import "../Skeleton/Skeleton.scss";
import "./ProductPageSkeleton.scss";

function ProductPageSkeleton() {
  return (
    <div
      className="product-page-skeleton"
      aria-busy="true"
      aria-label="Loading product"
    >
      <div className="product-page-skeleton__carousel skeleton-shimmer" />
      <div className="product-page-skeleton__details">
        <div className="product-page-skeleton__title skeleton-shimmer" />
        {Array.from({ length: 5 }, (_, i) => (
          <div
            key={i}
            className={
              i > 2
                ? "product-page-skeleton__line product-page-skeleton__line--short skeleton-shimmer"
                : "product-page-skeleton__line skeleton-shimmer"
            }
          />
        ))}
        <div className="product-page-skeleton__block skeleton-shimmer" />
        <div className="product-page-skeleton__block skeleton-shimmer" />
      </div>
    </div>
  );
}

export default ProductPageSkeleton;
